import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import { ENT_SUPPLIER_USER_LIST, ENT_SUPPLIER_USER_ADD, ENT_SUPPLIER_USER_DETAIL, ENT_SUPPLIER_USER_UPDATE } from '../../actions';
import {
  EnterpriseSupplierUserListSuccess, EnterpriseSupplierUserListError,
  EnterpriseSupplierUserAddSuccess, EnterpriseSupplierUserAddError,
  EnterpriseSupplierUserDetailSuccess, EnterpriseSupplierUserDetailError,
  EnterpriseSupplierUserUpdateSuccess, EnterpriseSupplierUserUpdateError
} from '../../actions';

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => { unsubscribe(); resolve(token); });
    }, reject);
  });
}

const onListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'enterprise/supplier_user/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'enterprise/supplier_user/add', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data.payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { message: true, data: response };
};

const onDetailAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'enterprise/supplier_user/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'enterprise/supplier_user/update', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  }).then(r => r.json()).catch(err => console.log(err));
  return { message: true, data: response };
};

function* onList(data) {
  try { const response = yield call(onListAsync, data.payload); yield put(EnterpriseSupplierUserListSuccess(response.data)); }
  catch (error) { yield put(EnterpriseSupplierUserListError(error)); }
}

function* onAdd(data) {
  try {
    const response = yield call(onAddAsync, data);
    if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    else if (response.data.status === 'error') NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    yield put(EnterpriseSupplierUserAddSuccess(response.data));
  } catch (error) { yield put(EnterpriseSupplierUserAddError(error)); }
}

function* onDetail(data) {
  try { const response = yield call(onDetailAsync, data.payload); yield put(EnterpriseSupplierUserDetailSuccess(response.data.data)); }
  catch (error) { yield put(EnterpriseSupplierUserDetailError(error)); }
}

function* onUpdate(data) {
  try {
    const response = yield call(onUpdateAsync, data.payload);
    if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    else if (response.data.status === 'error') NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    yield put(EnterpriseSupplierUserUpdateSuccess(response.data));
  } catch (error) { yield put(EnterpriseSupplierUserUpdateError(error)); }
}

export function* watchList() { yield takeEvery(ENT_SUPPLIER_USER_LIST, onList); }
export function* watchAdd() { yield takeEvery(ENT_SUPPLIER_USER_ADD, onAdd); }
export function* watchDetail() { yield takeEvery(ENT_SUPPLIER_USER_DETAIL, onDetail); }
export function* watchUpdate() { yield takeEvery(ENT_SUPPLIER_USER_UPDATE, onUpdate); }

export default function* rootSaga() {
  yield all([fork(watchList), fork(watchAdd), fork(watchDetail), fork(watchUpdate)]);
}
